export enum BOType {
  ADR7 = 'ADR7',
  ADR8 = 'ADR8'
}
